<div class="login-container">

  <div class="login" *ngIf="!resending.status || resending.status != 'sent'">

    <!-- <h2 class="ui header">Login</h2> -->

    <div class="section-title centered">Login</div>

    <div *ngIf="!loggingIn.inProgress; else loader">

      <div *ngIf="loggedOut" class="ui success message">
        <p>You have been successfully logged out.</p>
      </div>

      <div *ngIf="loginFailed" class="ui message negative centered">

        <div *ngIf="loginError">
          <div class="font-weight-600 centered error-title">{{ loginError.title }}</div>
          <div>{{ loginError.message }}</div>


          <div *ngIf="!resending.status || resending.status != 'sent'">
            <a *ngIf="showResendLink" class="ui button red-button tiny resend-link" (click)="resendConfirmation()"
              [ngClass]="{'loading': resending.status == 'sending', 'sent': resending.status == 'sent'}">
              Resend Verification Email
            </a>

          </div>


        </div>

        <div *ngIf="!loginError">
          Login failed. Please check your email/password and try again.
        </div>

      </div>

      <div *ngIf="!serviceEnabled || defaultLogin != 'service'" class="local-login">

        <div class="ui form">

          <div class="field">
            <div class="ui left icon input">
              <i class="user icon"></i>
              <input type="text" name="username" placeholder="E-mail address" [(ngModel)]="loginInfo.username">
            </div>
          </div>
          <div class="field">
            <div class="ui left icon input">
              <i class="lock icon"></i>
              <input type="password" name="password" placeholder="Password" [(ngModel)]="loginInfo.password">
            </div>
          </div>
          <button class="ui fluid large primary button" (click)="submitLogin()">Login</button>
          <div class="forgot-password-link">
            <a routerLink="/auth/password/forgot">Forgot your password?</a>
          </div>

          <div class="ui error message"></div>

        </div>

      </div>

    </div>

    <ng-template #loader>
      <app-loading [loadingText]="loggingIn.message"></app-loading>
    </ng-template>

  </div>

  <div *ngIf="resending.status == 'sent'">

    <div class="section-title centered">Verify Your Account</div>

    <div class="confirmation-sent">
      Verification email has been sent to your email address. Please click on the link in the email to finish the
      registration process. If you do not receive email please check your spam and junk folders.
    </div>

  </div>

</div>